import React, { useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, MapPinIcon, QrCodeIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { ResearchSource } from './ResearchSource';
const intelligence = [['INTERACTION', 'Who joined the experience?'], ['ENGAGEMENT', 'How did people interact with it?'], ['CATCH', 'What was caught?'], ['REDEMPTION', 'What was actually collected?'], ['EXPERIENCE', 'What did people think?'], ['INSIGHT', 'What can the brand learn?']];
const controls = [['AUDIENCE', 'Define who the experience is designed for.'], ['LOCATION', 'Run local, regional or national campaigns.'], ['QUANTITY', 'Control products available.'], ['EXPERIENCE', 'Choose the interaction.'], ['TIME', 'Schedule drops or always-on campaigns.'], ['REDEMPTION', 'Connect catches with participating locations.']];
export function BrandPlatform() {
  return <div id="for-brands" data-id="element-71" data-mp="6sxmnw80uo3">
      <ImagineCampaign data-id="element-72" data-mp="7kv649dp2h0" />
      <BuiltForBrands data-id="element-73" data-mp="842kr1ek8gs" />
      <CampaignManager data-id="element-74" data-mp="8vy61v02672" />
      <CampaignControl data-id="element-75" data-mp="25qk4enoe4vxw" />
      <Redemption data-id="element-76" data-mp="25rbph4kd3b9x" />
      <Feedback data-id="element-77" data-mp="25rv8yppnu7q2" />
    </div>;
}
function ImagineCampaign() {
  return <section className="bg-[#f7f5ef] px-5 py-24 md:px-10 md:py-32" aria-labelledby="imagine-heading" data-id="element-78" data-mp="2aotwgpetjgfa">
      <div className="mx-auto max-w-[1280px]" data-id="element-79" data-mp="2fo6khdhfetjg">
        <p className="text-xs font-extrabold tracking-[0.16em] text-black/45" data-id="element-80" data-mp="2fmdc9tr6019c">
          IMAGINE THIS
        </p>
        <h2 id="imagine-heading" className="mt-5 max-w-5xl font-display text-5xl font-bold leading-[0.9] md:text-7xl" data-id="element-81" data-mp="2kgzt4cg0mm0t">
          10,000 products.
          <br data-id="element-82" data-mp="2tetlxdekmxj8" />
          One city.
          <br data-id="element-83" data-mp="2thxxivud8vjx" />
          <span className="text-[#ff4d17]" data-id="element-84" data-mp="2thpgcrr7n42x">
            One experience people actually want to join.
          </span>
        </h2>
        <div className="mt-16 overflow-hidden border border-black/15 bg-white" data-id="element-85" data-mp="33eaovn2fuxbi">
          <div className="flex flex-wrap items-center justify-between gap-4 border-b border-black/10 px-5 py-4" data-id="element-86" data-mp="1416jtef69y1v">
            <div data-id="element-87" data-mp="18zhutsh7eelo">
              <p className="text-xs font-bold tracking-[0.12em] text-black/45" data-id="element-88" data-mp="1912o7ers7rhy">
                DEMO CAMPAIGN
              </p>
              <p className="mt-1 font-display text-2xl font-bold" data-id="element-89" data-mp="10zllow2vmydq">
                STOCKHOLM PRODUCT DROP
              </p>
            </div>
            <span className="rounded-full bg-[#ff4d17] px-3 py-1.5 text-xs font-extrabold text-white" data-id="element-90" data-mp="1ax80zjo38ry8">
              ILLUSTRATIVE LIVE STATE
            </span>
          </div>
          <div className="grid lg:grid-cols-[1fr_0.85fr]" data-id="element-91" data-mp="160rf6w4d2pob">
            <div className="relative min-h-[400px] overflow-hidden bg-[#e9e5db] p-6" data-id="element-92" data-mp="1jwv5wfg10fw1">
              <div className="poster-rules absolute inset-0 opacity-50" data-id="element-93" data-mp="1fvjf46lf1om9" />
              <MapPinIcon className="absolute left-[20%] top-[28%] text-[#ff4d17]" size={34} data-id="element-94" data-mp="1tnpqzghjd9fw" />
              <MapPinIcon className="absolute left-[60%] top-[48%] text-[#ff4d17]" size={34} data-id="element-95" data-mp="1op685oy8odrr" />
              <MapPinIcon className="absolute bottom-[17%] right-[18%] text-[#ff4d17]" size={34} data-id="element-96" data-mp="23lx8q1jnfviy" />
              <div className="absolute bottom-6 left-6 max-w-[330px] bg-black p-5 text-white" data-id="element-97" data-mp="1ync7bysnv5sx">
                <p className="text-xs font-extrabold tracking-[0.14em] text-[#ff4d17]" data-id="element-98" data-mp="2i8vvvkbh43rv">
                  STOCKHOLM, SWEDEN
                </p>
                <p className="mt-3 font-display text-3xl font-bold leading-none" data-id="element-99" data-mp="2m963f1ewz28u">
                  10,000 KEXCHOKLAD ARE SWIMMING IN STOCKHOLM.
                </p>
                <p className="mt-4 text-sm font-bold" data-id="element-100" data-mp="2d9j2shu0e0gu">GO CATCH ONE.</p>
              </div>
            </div>
            <div className="p-6 md:p-8" data-id="element-101" data-mp="1ykd20pfiw26u">
              <p className="text-[10px] font-extrabold tracking-[0.12em] text-black/40" data-id="element-102" data-mp="1yjbo8d74h1lf">
                ILLUSTRATIVE CAMPAIGN DATA
              </p>
              <div className="mt-8 grid grid-cols-2 gap-6" data-id="element-103" data-mp="1pkqcb0w5oktm">
                {[['10,000', 'PRODUCTS RELEASED'], ['8,421', 'PEOPLE JOINED'], ['31,204', 'CASTS'], ['7,842', 'PRODUCTS CAUGHT'], ['5,921', 'REDEEMED'], ['4.7 / 5', 'EXPERIENCE SCORE']].map(([value, label]) => <div key={label} data-id="element-104" data-mp="1fmsmwa2k8hzf">
                    <p className="font-display text-3xl font-bold" data-id="element-105" data-mp="1kku5yuzzkhaw">{value}</p>
                    <p className="mt-1 text-[9px] font-extrabold tracking-[0.1em] text-black/55" data-id="element-106" data-mp="1kmya9e1sribp">
                      {label}
                    </p>
                  </div>)}
              </div>
              <p className="mt-8 border-t border-black/10 pt-4 text-xs font-bold leading-relaxed text-black/65" data-id="element-107" data-mp="2iz11y91tjrma">
                DEMO VALUES ONLY — a live campaign view would be underpinned by
                release, experience-start, catch, redemption, and feedback
                events.
              </p>
            </div>
          </div>
        </div>
        <ResearchSource sourceId="DP-02" status="illustrative" title="Stockholm Product Drop campaign card" summary="The campaign title, product reference, map markers, and values in this card are illustrative content used to demonstrate the shape of a campaign view." methodology="A production campaign record would require approved campaign configuration and defined event lineage. This card does not indicate a live campaign or reporting feature." className="mt-5" data-id="element-108" data-mp="205dnmz7kgc9y" />
      </div>
    </section>;
}
function BuiltForBrands() {
  const reduceMotion = useReducedMotion();
  return <section className="bg-black px-5 py-24 text-white md:px-10 md:py-32" aria-labelledby="brands-heading" data-id="element-109" data-mp="z8a7lsf09t2">
      <div className="mx-auto max-w-[1280px]" data-id="element-110" data-mp="5pothmix2pnc">
        <p className="text-xs font-extrabold tracking-[0.16em] text-white/45" data-id="element-111" data-mp="5r03i42ygtmw">
          BUILT FOR BRAND TEAMS
        </p>
        <h2 id="brands-heading" className="mt-5 max-w-4xl font-display text-5xl font-bold leading-[0.9] md:text-7xl" data-id="element-112" data-mp="396yk5pvja56r">
          Sampling shouldn’t end when the product is handed out.
        </h2>
        <motion.p initial={reduceMotion ? false : {
        opacity: 1
      }} whileInView={{
        opacity: 0.28
      }} viewport={{
        once: false,
        amount: 0.7
      }} className="mt-20 font-display text-4xl font-bold line-through decoration-[#ff4d17] decoration-4 md:text-7xl" data-id="element-113" data-mp="3e7uvupm4mvmq">
          How many products did we distribute?
        </motion.p>
        <motion.p initial={reduceMotion ? false : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-5 font-display text-5xl font-bold text-[#ff4d17] md:text-8xl" data-id="element-114" data-mp="13cfc421r2m8g">
          What actually happened?
        </motion.p>
        <div className="mt-16 grid gap-y-10 border-t border-white/20 pt-10 md:grid-cols-2 md:gap-x-20" data-id="element-115" data-mp="38fp9dneensuj">
          {intelligence.map(([title, copy], index) => <article key={title} className="flex gap-5 border-b border-white/15 pb-8" data-id="element-116" data-mp="2gpucn5o7x0vu" data-mpi={index}>
              <span className="font-display text-3xl font-bold text-[#ff4d17]" data-id="element-117" data-mp="2bs2ie503p2oh">
                0{index + 1}
              </span>
              <div data-id="element-118" data-mp="2pjqtq62izn4e">
                <h3 className="text-sm font-extrabold tracking-[0.12em]" data-id="element-119" data-mp="2pk8qd3t3o3cu">
                  {title}
                </h3>
                <p className="mt-3 text-white/60" data-id="element-120" data-mp="1x2mv4yzs3fdj">{copy}</p>
              </div>
            </article>)}
        </div>
        <p className="mt-12 font-display text-4xl font-bold md:text-6xl" data-id="element-121" data-mp="1t1b0gf21s3yh">
          From distribution to understanding.
        </p>
      </div>
    </section>;
}
function CampaignManager() {
  const [filter, setFilter] = useState('ENGAGEMENT');
  const reduceMotion = useReducedMotion();
  const bars = filter === 'CATCHES' ? [32, 52, 44, 75, 81, 63, 93, 72] : filter === 'REDEMPTIONS' ? [18, 28, 35, 56, 53, 69, 62, 77] : [40, 58, 49, 68, 88, 72, 92, 85];
  return <section className="bg-[#f7f5ef] px-5 py-24 md:px-10 md:py-32" aria-labelledby="manager-heading" data-id="element-122" data-mp="1dyay9k62b91s">
      <div className="mx-auto max-w-[1280px]" data-id="element-123" data-mp="21odsa5tjep31">
        <p className="text-xs font-extrabold tracking-[0.16em] text-black/45" data-id="element-124" data-mp="26n8gxoe6r7v2">
          SAMPLER CAMPAIGN MANAGER
        </p>
        <h2 id="manager-heading" className="mt-5 font-display text-5xl font-bold leading-[0.9] md:text-7xl" data-id="element-125" data-mp="1romv1wdldvz9">
          See the experience as it happens.
        </h2>
        <div className="mt-14 overflow-hidden rounded-[28px] border border-black/15 bg-[#11110f] text-white shadow-[14px_14px_0_#ff4d17]" data-id="element-126" data-mp="g9rh6cmrryjr">
          <div className="flex flex-wrap items-center justify-between gap-4 border-b border-white/15 px-5 py-5 md:px-7" data-id="element-127" data-mp="laxbufzzpvvx">
            <div data-id="element-128" data-mp="2gqi5w5l580i">
              <p className="font-bold" data-id="element-129" data-mp="3tp4diois6o2d">STOCKHOLM PRODUCT DROP</p>
              <p className="mt-1 text-xs text-white/45" data-id="element-130" data-mp="3tnt7sj5rz68m">
                ILLUSTRATIVE DASHBOARD DATA
              </p>
            </div>
            <span className="rounded-full border border-[#ff4d17] px-3 py-1.5 text-xs font-bold text-[#ff4d17]" data-id="element-131" data-mp="3kofzvuxaupq0">
              DEMO STATUS: ILLUSTRATIVE LIVE STATE
            </span>
          </div>
          <div className="grid gap-5 p-5 md:p-7 lg:grid-cols-[1.35fr_0.65fr]" data-id="element-132" data-mp="ga7yl82z64mb">
            <div className="space-y-5" data-id="element-133" data-mp="gcaxkhm3v836">
              <div className="grid grid-cols-2 gap-3 md:grid-cols-3" data-id="element-134" data-mp="bipz6ogloc3g">
                {[['10,000', 'PRODUCTS AVAILABLE'], ['12,482', 'EXPERIENCES STARTED'], ['8,721', 'CATCHES'], ['6,283', 'REDEMPTIONS'], ['72%', 'REDEMPTION RATE'], ['4.6 / 5', 'EXPERIENCE SCORE']].map(([value, label]) => <div key={label} className="border border-white/15 p-4" data-id="element-135" data-mp="z93uqoye8t2s">
                    <p className="font-display text-3xl font-bold" data-id="element-136" data-mp="z6zfjav1o7n7">{value}</p>
                    <p className="mt-2 text-[9px] font-extrabold tracking-[0.09em] text-white/45" data-id="element-137" data-mp="2hxeqpvjsamg0">
                      {label}
                    </p>
                  </div>)}
              </div>
              <div className="border border-white/15 p-5" data-id="element-138" data-mp="2qvqnygf5oihf">
                <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-139" data-mp="2vvd1kqywc0qr">
                  <div data-id="element-140" data-mp="30upotctoj9tv">
                    <p className="font-bold" data-id="element-141" data-mp="30vhmct6u7hms">CAMPAIGN MAP / DEMO</p>
                    <p className="text-xs text-white/45" data-id="element-142" data-mp="35tswl511nu5j">
                      Stockholm activity / illustrative view
                    </p>
                  </div>
                  <div className="flex gap-1" role="group" aria-label="Illustrative campaign map filter" data-id="element-143" data-mp="3al16012djfip">
                    {['ENGAGEMENT', 'CATCHES', 'REDEMPTIONS'].map(item => {
                    const isSelected = filter === item;
                    return <button key={item} type="button" aria-pressed={isSelected} onClick={() => setFilter(item)} className={`rounded-full px-3 py-1.5 text-[10px] font-bold transition-colors ${isSelected ? 'bg-[#ff4d17] text-white shadow-[0_0_0_1px_#ff4d17]' : 'border border-white/30 text-white/80 hover:border-white hover:text-white'}`} data-id="element-144" data-mp="3ok0th5e5hoda">
                          {item}
                        </button>;
                  })}
                  </div>
                </div>
                <div className="relative mt-5 h-44 overflow-hidden border border-white/10" data-id="element-145" data-mp="13p3s9j28wf4q">
                  <motion.div animate={{
                  x: filter === 'ENGAGEMENT' ? '0%' : filter === 'CATCHES' ? '40%' : '12%',
                  y: filter === 'REDEMPTIONS' ? '42%' : '0%',
                  scale: filter === 'ENGAGEMENT' ? 1 : filter === 'CATCHES' ? 0.78 : 1.15
                }} transition={{
                  duration: reduceMotion ? 0 : 0.35,
                  ease: [0.22, 1, 0.36, 1]
                }} className="absolute left-[25%] top-[30%] h-16 w-16 rounded-full bg-[#ff4d17]/30" data-id="element-146" data-mp="18lu2hprdcgi8" />
                  <motion.div animate={{
                  x: filter === 'REDEMPTIONS' ? '-38%' : filter === 'CATCHES' ? '14%' : '0%',
                  y: filter === 'ENGAGEMENT' ? '0%' : '-18%',
                  scale: filter === 'REDEMPTIONS' ? 1.2 : 0.9
                }} transition={{
                  duration: reduceMotion ? 0 : 0.35,
                  ease: [0.22, 1, 0.36, 1]
                }} className="absolute bottom-[15%] right-[22%] h-20 w-20 rounded-full bg-[#ff4d17]/20" data-id="element-147" data-mp="3of1g3cvyam3c" />
                  <p className="absolute bottom-3 left-3 text-[10px] font-bold text-white/70" data-id="element-148" data-mp="3kt86h2u0hef">
                    STOCKHOLM
                  </p>
                </div>
                <p className="mt-3 text-[10px] font-bold tracking-[0.08em] text-white/70" aria-live="polite" data-id="element-149" data-mp="3qqbs6xsqa8yx">
                  SHOWING ILLUSTRATIVE {filter} VIEW — ANIMATED PROTOTYPE STATE
                </p>
              </div>
              <div className="border border-white/15 p-5" data-id="element-150" data-mp="2faddadavcsps">
                <p className="text-sm font-bold" data-id="element-151" data-mp="2actztflzwjyw">CAMPAIGN FUNNEL</p>
                <div className="mt-5 flex h-28 items-end gap-2" data-id="element-152" data-mp="2buaj4h7gdvjc">
                  {bars.map((height, index) => <span key={index} className="flex h-full flex-1 items-end overflow-hidden" data-id="element-153" data-mp="2gtn40werksja" data-mpi={index}>
                      <motion.span initial={reduceMotion ? false : {
                    scaleY: 0
                  }} animate={{
                    scaleY: height / 100
                  }} transition={{
                    delay: reduceMotion ? 0 : index * 0.04,
                    duration: 0.42,
                    ease: [0.22, 1, 0.36, 1]
                  }} className="h-full w-full origin-bottom bg-[#ff4d17]" data-id="element-154" data-mp="22udzitzx7mv5" />
                    </span>)}
                </div>
                <div className="mt-3 grid grid-cols-5 gap-1 text-[8px] font-bold tracking-[0.06em] text-white/45" data-id="element-155" data-mp="1j41zsm16l536">
                  <span data-id="element-156" data-mp="1a5gieu7g3w3z">
                    12,482
                    <br data-id="element-157" data-mp="1a6rl0qp5mxti" />
                    EXPERIENCES
                  </span>
                  <span data-id="element-158" data-mp="1f3i13e0yltex">
                    10,204
                    <br data-id="element-159" data-mp="1f6cjz14br668" />
                    ENGAGED
                  </span>
                  <span data-id="element-160" data-mp="vj002wgcnael">
                    8,721
                    <br data-id="element-161" data-mp="qk6hipm7gt7k" />
                    CAUGHT
                  </span>
                  <span data-id="element-162" data-mp="14jg1m0dj87gt">
                    6,283
                    <br data-id="element-163" data-mp="14k7jy9i4c8p5" />
                    REDEEMED
                  </span>
                  <span data-id="element-164" data-mp="10hkxko47vfzc">
                    4,921
                    <br data-id="element-165" data-mp="10k772tao45k7" />
                    FEEDBACK
                  </span>
                </div>
              </div>
            </div>
            <aside className="border border-white/15 p-5" data-id="element-166" data-mp="19j10kaspcftj">
              <p className="text-xs font-extrabold tracking-[0.12em] text-[#ff4d17]" data-id="element-167" data-mp="19gepi16lri6k">
                CAMPAIGN PULSE
              </p>
              <p className="mt-5 font-display text-4xl font-bold" data-id="element-168" data-mp="1j7snu5mtiby4">Now.</p>
              <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-169" data-mp="1jaonbyebd8oo">
                Follow the physical product experience while the campaign is
                happening. This is a visual platform concept, not a claim of
                current reporting features.
              </p>
              <div className="mt-8 border-t border-white/15 pt-5 text-xs leading-loose text-white/50" data-id="element-170" data-mp="3mn4lc9nrbegf">
                ENGAGEMENT
                <br data-id="element-171" data-mp="94h37i6xjdf" />
                CATCHES
                <br data-id="element-172" data-mp="a61w3p0dk8c" />
                REDEMPTIONS
                <br data-id="element-173" data-mp="4azq6y6d511r" />
                FEEDBACK
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>;
}
function CampaignControl() {
  return <section className="bg-white px-5 py-24 md:px-10 md:py-32" aria-labelledby="control-heading" data-id="element-174" data-mp="33sppgswqs1wt">
      <div className="mx-auto max-w-[1280px]" data-id="element-175" data-mp="38ranqmsfobim">
        <p className="text-xs font-extrabold tracking-[0.16em] text-black/45" data-id="element-176" data-mp="3cpzys8q01gz3">
          YOUR PRODUCT. YOUR CAMPAIGN.
        </p>
        <h2 id="control-heading" className="mt-5 font-display text-5xl font-bold leading-[0.85] md:text-8xl" data-id="element-177" data-mp="3hrfmk8jka1l6">
          Decide who.
          <br data-id="element-178" data-mp="wzx1uig2jzlj" />
          Where.
          <br data-id="element-179" data-mp="wyvno53rawzl" />
          When. How.
        </h2>
        <div className="mt-14 grid border-l border-t border-black/15 md:grid-cols-2 lg:grid-cols-3" data-id="element-180" data-mp="x1q6js74g9qw">
          {controls.map(([title, copy]) => <article key={title} className="border-b border-r border-black/15 p-6 md:p-8" data-id="element-181" data-mp="1248y3cxcg5uw">
              <p className="text-xs font-extrabold tracking-[0.12em] text-[#ff4d17]" data-id="element-182" data-mp="xdipzrxj9owi">
                {title}
              </p>
              <p className="mt-8 max-w-xs text-lg font-bold leading-tight" data-id="element-183" data-mp="tbnqmsz5xlld">
                {copy}
              </p>
              <ChevronDownIcon className="mt-10 text-black/40" size={20} data-id="element-184" data-mp="oex8m03ssfxb" />
            </article>)}
        </div>
        <p className="mt-5 text-xs text-black/40" data-id="element-185" data-mp="jcy9x3j0676p">
          PLATFORM CONCEPT — controls illustrate the intended campaign setup
          direction.
        </p>
        <p className="mt-12 font-display text-4xl font-bold md:text-6xl" data-id="element-186" data-mp="aemjp2m1tbes">
          Sampling becomes a campaign tool.
          <br data-id="element-187" data-mp="28snun1h85xir" />
          <span className="text-black/35" data-id="element-188" data-mp="28sedm3e5r0p7">Not a logistical event.</span>
        </p>
      </div>
    </section>;
}
function Redemption() {
  const [passShown, setPassShown] = useState(false);
  const reduceMotion = useReducedMotion();
  return <section className="bg-[#ff4d17] px-5 py-24 text-black md:px-10 md:py-32" aria-labelledby="redemption-heading" data-id="element-189" data-mp="6vdocswqblw9">
      <div className="mx-auto grid max-w-[1280px] gap-10 lg:grid-cols-[1fr_0.75fr] lg:items-center" data-id="element-190" data-mp="3pafu5nazdntc">
        <div data-id="element-191" data-mp="3taglu9n3bvic">
          <p className="text-xs font-extrabold tracking-[0.16em] text-black/60" data-id="element-192" data-mp="3tc1f7vxo58em">
            DIGITAL DISCOVERY. PHYSICAL PRODUCT.
          </p>
          <h2 id="redemption-heading" className="mt-5 font-display text-5xl font-bold leading-[0.88] md:text-7xl" data-id="element-193" data-mp="ktlsplw3hphg">
            Catch it on your phone.
            <br data-id="element-194" data-mp="btp0596l46h4" />
            Get it in the real world.
          </h2>
          <p className="mt-8 max-w-xl text-lg leading-relaxed text-black/80" data-id="element-195" data-mp="gtl5bbr0q3y9">
            A catch can live in the consumer account, then move through a simple
            partner redemption flow. This is product direction for the Sampler
            redemption experience.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-3 text-sm font-extrabold" data-id="element-196" data-mp="2t31ntiketno6">
            <span data-id="element-197" data-mp="2p1ggsduk43lw">PHONE</span>
            <span data-id="element-198" data-mp="2p280oreskcwc">↓</span>
            <span data-id="element-199" data-mp="2p0on58kisfy9">QR SCAN</span>
            <span data-id="element-200" data-mp="2p3svmi50pxuq">↓</span>
            <span data-id="element-201" data-mp="330zf6exkg0l0">PRODUCT REDEEMED</span>
          </div>
        </div>
        <motion.div initial={reduceMotion ? false : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mx-auto w-full max-w-[340px] rounded-[42px] border-[8px] border-black bg-black p-2 shadow-[14px_14px_0_white]" data-id="element-202" data-mp="32z4yxdx8own9">
          <div className="rounded-[30px] bg-[#f7f5ef] p-6 text-center" data-id="element-203" data-mp="2k2dakq2ubrcc">
            <p className="text-xs font-extrabold tracking-[0.14em] text-[#ff4d17]" data-id="element-204" data-mp="2k4g9y0pvuwtq">
              CONGRATS
            </p>
            <p className="mt-4 font-display text-3xl font-bold leading-none" data-id="element-205" data-mp="1rm2jim6vmd4o">
              YOU CAUGHT A KEXCHOKLAD.
            </p>
            <p className="mt-5 text-xs font-bold text-black/60" data-id="element-206" data-mp="1mnr8470xnukc">
              ILLUSTRATIVE CATCH
            </p>
            <div className="mx-auto mt-5 grid h-44 w-44 grid-cols-7 gap-1 bg-white p-3" data-id="element-207" data-mp="114y64lww6bqp">
              {Array.from({
              length: 49
            }, (_, i) => <span key={i} className={i % 3 === 0 || i % 7 === 0 || i === 11 || i === 29 ? 'bg-black' : 'bg-white'} data-id="element-208" data-mp="1b1u9yebui9ox" />)}
            </div>
            <button type="button" aria-pressed={passShown} onClick={() => setPassShown(current => !current)} className={`mt-6 w-full rounded-xl py-4 text-sm font-extrabold transition-colors ${passShown ? 'bg-[#ff4d17] text-white' : 'bg-black text-white hover:bg-black/80'}`} data-id="element-209" data-mp="1g1ys08sejch9">
              {passShown ? 'PASS SHOWN — TAP TO RESET' : 'SHOW TO STAFF'}
            </button>
            <div className="mt-4 flex items-center justify-center gap-2 text-sm font-bold text-emerald-800" aria-live="polite" data-id="element-210" data-mp="1yry9oalwxpan">
              <CheckCircle2Icon size={18} aria-hidden="true" data-id="element-211" data-mp="23rt0ke5ouevp" />
              {passShown ? 'DEMO PASS DISPLAYED' : 'REDEMPTION FLOW CONCEPT'}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}
function Feedback() {
  const [intent, setIntent] = useState<string | null>(null);
  const [word, setWord] = useState<string | null>(null);
  return <section className="bg-[#f7f5ef] px-5 py-24 md:px-10 md:py-32" aria-labelledby="feedback-heading" data-id="element-212" data-mp="3j97dvnn9u8pc">
      <div className="mx-auto grid max-w-[1280px] gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-213" data-mp="3eaw6rkod2cat">
        <div data-id="element-214" data-mp="ft8o9ccptmtc">
          <p className="text-xs font-extrabold tracking-[0.16em] text-black/45" data-id="element-215" data-mp="frp8rnyvvfsm">
            THE EXPERIENCE CONTINUES
          </p>
          <h2 id="feedback-heading" className="mt-5 font-display text-5xl font-bold leading-[0.9] md:text-7xl" data-id="element-216" data-mp="aufm2g2vpi8h">
            The product was redeemed.
            <br data-id="element-217" data-mp="14clnutfh204" />
            Now learn what happened.
          </h2>
          <p className="mt-7 max-w-lg text-lg leading-relaxed text-black/65" data-id="element-218" data-mp="1203bgjrcpmj">
            Every product experience can create a signal. This is the intended
            feedback direction, not an AI or intelligence claim.
          </p>
        </div>
        <div className="relative border border-black/15 bg-white p-6 md:p-8" data-id="element-219" data-mp="1bgrw53vy2jsj">
          <p className="text-xs font-extrabold tracking-[0.14em] text-[#ff4d17]" data-id="element-220" data-mp="16g48ms6xcl32">
            PRODUCT DIRECTION
          </p>
          <h3 className="mt-7 font-display text-4xl font-bold" data-id="element-221" data-mp="11ic5t34qrek3">HOW WAS IT?</h3>
          <p className="mt-4 text-3xl tracking-[0.18em] text-[#ff4d17]" data-id="element-222" data-mp="xgqydxaz7sha">
            ★★★★★
          </p>
          <p className="mt-8 text-sm font-bold" data-id="element-223" data-mp="1u6hv836qprq9">WOULD YOU BUY IT?</p>
          <div className="mt-3 flex flex-wrap gap-2" data-id="element-224" data-mp="1p759jlrluqp9">
            {['YES', 'MAYBE', 'NO'].map(item => <button type="button" key={item} aria-pressed={intent === item} onClick={() => setIntent(item)} className={`border px-4 py-2 text-xs font-extrabold transition-colors ${intent === item ? 'border-black bg-black text-white' : 'border-black/20 hover:bg-black hover:text-white'}`} data-id="element-225" data-mp="1kgf11znvu7qc">
                {item}
              </button>)}
          </div>
          <p className="mt-8 text-sm font-bold" data-id="element-226" data-mp="2857qdda01hbz">DESCRIBE IT IN ONE WORD.</p>
          <div className="mt-3 flex flex-wrap gap-2" data-id="element-227" data-mp="3qtiyfi8nz15k">
            {['FRESH', 'SMOOTH', 'SWEET', 'SURPRISING', 'OTHER'].map(item => <button type="button" key={item} aria-pressed={word === item} onClick={() => setWord(item)} className={`border px-3 py-2 text-xs font-bold transition-colors ${word === item ? 'border-[#ff4d17] bg-[#ff4d17] text-white' : 'border-black/15 text-black/60 hover:border-black'}`} data-id="element-228" data-mp="3vsn624fxwqts">
                {item}
              </button>)}
          </div>
          <div className="mt-10 flex items-center gap-3 border-t border-black/10 pt-5 text-sm font-bold" data-id="element-229" data-mp="ilc1g24op996">
            <QrCodeIcon size={19} className="text-[#ff4d17]" aria-hidden="true" data-id="element-230" data-mp="ncaix51esde0" />
            <span data-id="element-231" data-mp="neemflvebadr">
              {intent || word ? 'ILLUSTRATIVE FEEDBACK SELECTION RECORDED' : 'SIGNAL RETURNS TO CAMPAIGN DATA'}
            </span>
          </div>
          <p className="mt-3 text-xs font-bold text-black/60" aria-live="polite" data-id="element-232" data-mp="wea1i1s2npj2">
            {intent && word ? `DEMO RESPONSE: ${intent} · ${word}` : 'SELECT AN OPTION TO PREVIEW THE FEEDBACK STATE.'}
          </p>
        </div>
      </div>
    </section>;
}